export const calendar = {
  title: "Calendario (Channel Manager)",
  subtitle: "Todas las reservas de tus OTAs en un solo lugar",
  createBooking: "Crear reserva",
  propertyLabel: "Alojamiento",
  searchPlaceholder: "Buscar alojamiento",
  filterByProperty:"Filtrar alojamientos",
  connectChannels: "Conectar canales",
  clearFilters:"Limpiar",
  loadingMore: "Cargando más fechas…",



  "payment": {
    "pending":  "Pago pendiente",
    "paid":     "Pagado",
    "rejected": "Pago rechazado",
    "refunded": "Reembolsado",
    "partial":  "Pago parcial"
  },

  tooltips: {
    
    noChannels: "Sin conexión con ningún canal",
    connectedTo: "Conectado a: {channels}",
    manual: "WA Checkin (manual)",
    other: "Otro canal",
    configPrices: "Configurar precios"
  },

  errors: {
    loadCalendar: "Error al cargar datos del calendario",
    updateViewAfterCancel: "Error al actualizar la vista después de cancelar",
    closeDates: "Error al cerrar fechas",
    deleteClosedDates: "Error al eliminar fechas cerradas",
    updateClosedDates: "Error al actualizar fechas cerradas",
  },

  filters: {
    showPrices: "Mostrar precios",
    today: "Hoy",
    multi: "Múltiple",
    monthly: "Mensual",
    prevMonthAria: "Mes anterior",
    nextMonthAria: "Mes siguiente",
  },

  actions: {
    title: "Selecciona una acción",
    question: "¿Qué deseas hacer con las fechas seleccionadas?",
    createBooking: "Crear reserva",
    blockDates: "Cerrar fechas",
    editNightPrice: "Editar precio por noche",
    pricesManagedBy: "Tarifas gestionadas por PriceLabs",
    editMinStay: "Estancia mínima",
    editMinStayHint: "Configura el mínimo de noches por fecha",
  },
  minStayModal: {
    description:
      "Configura la estancia mínima de noches para el rango de fechas seleccionado. No afecta los precios existentes.",
    success: "Estancia mínima actualizada correctamente",
    hint: "Número mínimo de noches que debe reservar el huésped.",
    errors: {
      minOne: "La estancia mínima debe ser al menos 1 noche.",
    },
  },

  // NUEVO: campos genéricos reutilizables
  fields: {
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
  },

  // NUEVO: etiquetas de botones genéricas
  buttons: {
    delete: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar",
    close: "Cerrar",
    saveChanges: "Guardar cambios",
    closeDates: "Cerrar fechas",
  },

  // NUEVO: textos específicos del modal de cerrar fechas
  closeModal: {
    headerCreate: "CERRAR FECHAS",
    headerEdit: "EDITAR FECHA CERRADA",
  },

  priceModal: {
    description:
      "Este es un cambio manual de la tarifa que seleccionarás. Todo lo que cambies aquí tendrá impacto solamente en este alojamiento y este rango de fechas.",
    periodLabel: "Periodo de fechas",
    startPlaceholder: "Fecha de inicio",
    endPlaceholder: "Fecha de fin",
    pricePerNight: "Precio por noche",
    minStay: "Estancia mínima",
    minNightsPlaceholder: "Noches mínimas",
    pricePlaceholder: "Precio para el rango seleccionado",
    success: "Precios actualizados correctamente",
    errors: {
      invalidRange: "Debe seleccionar un rango de fechas válido",
      startAfterEnd: "La fecha de inicio no puede ser mayor a la fecha de fin",
      minStay:
        "La estancia mínima es de {min} noches, pero el rango seleccionado tiene {nights} noches",
      missingSelection: "No se ha seleccionado una propiedad o rango de fechas",
      request: "Error en la solicitud: {msg}",
      update: "Error al actualizar los precios: {msg}",
    },
  },

  details: {
    header: "Detalles de la reserva",
    title: "Reserva",
    createdOn: "Creada el {date}",
    checkIn: "Entrada",
    checkOut: "Salida",
    arrow: "→",
    statusLabel: "Estado",
    status: {
      booked: "Reservada",
      blocked: "Bloqueada",
    },
    night_one: "Noche",
    night_other: "Noches",
    actions: {
      view: "Ver reserva",
      changeRoom: "Cambiar habitación",
      cancel: "Cancelar reserva",
    },
  },
};

export default calendar;
